import { createSlice } from "@reduxjs/toolkit";
import { LatLng } from "leaflet";

export interface MapModel {
  isDraggable: boolean;
  showRegion: boolean;
  flytoLocation: LatLng;
}

const RequestMapSlice = createSlice({
  name: "mapSlice",
  initialState: {} as MapModel,
  reducers: {
    updateData: (state, action) => {
      state = {
        ...state,
        ...action.payload,
      };
      return state;
    },
  },
});

export default RequestMapSlice;
